import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=41ece4c5&scoped=true&"
import script from "./Competition.vue?vue&type=script&lang=js&"
export * from "./Competition.vue?vue&type=script&lang=js&"
import style0 from "./Competition.vue?vue&type=style&index=0&id=41ece4c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ece4c5",
  null
  
)

export default component.exports